import { render } from "./EmojiIcon.vue?vue&type=template&id=56b193e7&scoped=true"
import script from "./EmojiIcon.vue?vue&type=script&lang=js"
export * from "./EmojiIcon.vue?vue&type=script&lang=js"

import "./EmojiIcon.vue?vue&type=style&index=0&id=56b193e7&scoped=true&lang=css"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b193e7"]])

export default __exports__